export default __webpack_public_path__ + "static/media/background.295b62b3.jpg";